export interface ValidationFailure {
    code: string;
    message: string;
    severity: FailureSeverity;
}

export enum FailureSeverity {
    Error = 1,
    Warning = 2
}

export interface ValidationResult {
    isValid: boolean;
    failures: ValidationFailure[];
}

export const validationSuccessful = (): ValidationResult => {
    return createValidationResult();
};

export const validationFailed = (failures: ValidationFailure[]): ValidationResult => {
    return createValidationResult(failures);
};

export const createValidationResult = (failures?: (ValidationFailure | void)[]): ValidationResult => {
    return {
        isValid: !failures?.length,
        failures: failures?.filter(isNotVoid) ?? []
    };
};

export const createFailure = (message: string, code: string, severity?: FailureSeverity): ValidationFailure => {
    return {
        code,
        message,
        severity: severity ?? FailureSeverity.Error
    };
};

const isNotVoid = (failure: ValidationFailure | void): failure is ValidationFailure => !!failure;
